module.exports = __webpack_public_path__ + "templates.carousel-display-9772c4f1.html";